import { events } from './events';
import { Module } from './framework/module';
import { CookieConsentType } from './models/cookie-consent-type.enum';
import { PlEvent } from './models/pl.event';
import { store } from './store';
import { optIn } from './utils/opt-in.fn';
import { optOut } from './utils/opt-out.fn';

export class ConsentModule extends Module {
  async onInit() {
    events.on('set-consent', (event) => this.onSetConsent(event));
    events.on('add-consent', (event) => this.addConsent(event));
    events.on('remove-consent', (event) => this.removeConsent(event));
    events.on('toggle-consent', (event) => this.toggleConsent(event));
  }

  private async onSetConsent({ consent }: { consent: CookieConsentType[] }) {
    store.set('consent', consent);

    if (consent.includes(CookieConsentType.Statistics)) {
      optIn(CookieConsentType.Statistics);
    } else {
      optOut(CookieConsentType.Statistics);
    }

    if (consent.includes(CookieConsentType.Preferences)) {
      optIn(CookieConsentType.Preferences);
    } else {
      optOut(CookieConsentType.Preferences);
    }

    if (consent.includes(CookieConsentType.Marketing)) {
      optIn(CookieConsentType.Marketing);
    } else {
      optOut(CookieConsentType.Marketing);
    }

    const consentGiven = consent
      .sort()
      .map((type) => CookieConsentType[type])
      .join(', ');

    document.dispatchEvent(
      new PlEvent({
        goal: 'consent set',
        props: {
          consent: consentGiven,
        },
      })
    );

    events.emit('consent-set');
  }

  private addConsent({ consent }: { consent: CookieConsentType }) {
    const existingConsent = store.get('consent') ?? [];
    const index = existingConsent.indexOf(consent);

    if (index === -1) {
      existingConsent.push(consent);
    }

    events.emit('set-consent', { consent: existingConsent });
  }

  private removeConsent({ consent }: { consent: CookieConsentType }) {
    const existingConsent = store.get('consent') ?? [];
    const index = existingConsent.indexOf(consent);

    if (index > -1) {
      existingConsent.splice(index, 1);

      events.emit('set-consent', { consent: existingConsent });
    }
  }

  private toggleConsent({ consent }: { consent: CookieConsentType }) {
    const existingConsent = store.get('consent') ?? [];
    const index = existingConsent.indexOf(consent);

    if (index === -1) {
      events.emit('add-consent', { consent });
    } else {
      events.emit('remove-consent', { consent });
    }
  }
}
